import { API_URL } from '../config';

export const getTours = async () => {
  const res = await fetch(`${API_URL}/tours/`, {
    cache: "no-store"
  });
  return res.json();
};

export const getTour = async (slug) => {
  const res = await fetch(`${API_URL}/tours/${slug}/`, {
    cache: "no-store"
  });
  return res.json();
};
